import { render, staticRenderFns } from "./requests-page.vue?vue&type=template&id=eef58a52&scoped=true&"
import script from "./requests-page.vue?vue&type=script&lang=js&"
export * from "./requests-page.vue?vue&type=script&lang=js&"
import style0 from "./requests-page.vue?vue&type=style&index=0&id=eef58a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef58a52",
  null
  
)

export default component.exports